var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "wa-modal-frame",
    {
      attrs: {
        title: "Enable Auto Renew?",
        "has-actions": "",
        "is-showing": _vm.isShowing,
      },
      on: {
        "close-modal": function ($event) {
          return _vm.$emit("close-modal")
        },
      },
    },
    [
      _c("p", [
        _vm._v(
          "\n    Stop worrying about dates and expirations! Turn on auto-renew to continue to get access to all of the icons, features, and services your subscription\n    provides\n    "
        ),
        _c("strong", [_vm._v("every year")]),
        _vm._v("\n    including…\n  "),
      ]),
      _vm._v(" "),
      _c("wa-subscription-features"),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "message info with-icon margin-bottom-0" },
        [
          _c("font-awesome-icon", {
            staticClass: "decorative fa-rotate-180",
            attrs: { icon: _vm.$v7.regular.faStarShooting, size: "lg" },
          }),
          _vm._v(" "),
          _c("span", [
            _vm._v("\n      You'll be charged automatically on\n      "),
            _c("strong", [_vm._v(_vm._s(_vm.periodEndAtDate))]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ul",
        {
          staticClass:
            "display-flex flex-column flex-items-center tablet:flex-row tablet:flex-content-between tablet:flex-row-reverse",
          staticStyle: {
            "--list-style-type": "none",
            "--list-padding-left": "0",
            "--button-margin-bottom": "0",
            gap: "var(--spacing-md)",
          },
          attrs: { slot: "actions" },
          slot: "actions",
        },
        [
          _c(
            "li",
            [
              _vm.subscription.cancelAtPeriodEndAllowed
                ? _c("wa-action-button", {
                    attrs: {
                      "is-processing": _vm.isProcessing,
                      "icon-name": "faArrowsRotate",
                      "is-processing-label": "Setting Up Auto-Renew...",
                      label: "Enable Auto-Renew",
                      theme: "success",
                    },
                    on: { click: _vm.setupAutoRenewal },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("li", [
            _c(
              "button",
              {
                staticClass: "flat",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("close-modal")
                  },
                },
              },
              [_vm._v("\n        Cancel\n      ")]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }